var o={name:"rzTooltip",props:{dialogBottom:Boolean}};export{o as default};
